/** Paint the exact DOM grounds, including the actual SVG connector paths.
 * Screen CTMs include the connector's CSS mirror, scale and translation.
 * The texture only carries alpha; the shader supplies the panel's colour.
 */
export default function drawHeroRestMask(context, node, panels, bounds, dpr) {
	context.setTransform(dpr, 0, 0, dpr, 0, 0);
	context.fillStyle = '#fff';
	for (const panel of panels) {
		const r = panel.getBoundingClientRect();
		const radius =
			parseFloat(window.getComputedStyle(panel).borderTopLeftRadius) || 0;
		context.beginPath();
		context.roundRect(
			r.left - bounds.left,
			r.top - bounds.top,
			r.width,
			r.height,
			radius
		);
		context.fill();
	}
	for (const path of node.querySelectorAll('[data-hero-connector] path')) {
		if (!path.getBoundingClientRect().width) continue;
		const m = path.getScreenCTM();
		if (!m) continue;
		context.setTransform(
			m.a * dpr,
			m.b * dpr,
			m.c * dpr,
			m.d * dpr,
			(m.e - bounds.left) * dpr,
			(m.f - bounds.top) * dpr
		);
		context.fill(new window.Path2D(path.getAttribute('d')));
	}
}
